// extracted by mini-css-extract-plugin
export default {"active":"RadioButton_active__0PCYX","inactive":"RadioButton_inactive__an7Rh"};